import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CircularProgressProps } from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(() => ({
  loaderWrapper: {
    zIndex: 30000,
    height: ({ height }: { height: ContentLoaderHeightProp }) => height,
  },
}));

type ContentLoaderHeightProp = string | number;

export interface ContentLoaderProps extends CircularProgressProps {
  height?: ContentLoaderHeightProp;
}

const ContentLoader: React.FC<ContentLoaderProps> = ({
  size = 90,
  thickness = 1,
  color = 'primary',
  height = '60vh',
  ...props
}) => {
  const classes = useStyles({ height });

  return (
    <Box flex={1} display={'flex'} alignItems={'center'} justifyContent={'center'} className={classes.loaderWrapper}>
      <CircularProgress {...props} size={size} thickness={thickness} color={color} />
    </Box>
  );
};

export default ContentLoader;
